<div class="crm-integrations-banner">
  <button class="dismiss-btn" (click)="dismiss()" type="button">
    <ng-icon name="heroXMark"></ng-icon>
  </button>

  <div class="banner-illustration" aria-hidden="true">
    <img src="assets/images/crm-integrations-banner-art.png" alt="" />
  </div>

  <div class="banner-bottom">
    <p class="eyebrow">{{ 'CRM_INTEGRATIONS_BANNER.LABEL' | translate }}</p>
    <p class="title-text">{{ 'CRM_INTEGRATIONS_BANNER.TITLE' | translate }}</p>
  </div>

  <button class="cta-btn" (click)="navigate()" type="button" [attr.aria-label]="'CRM_INTEGRATIONS_BANNER.LABEL' | translate">
    <ng-icon name="heroArrowRightMini"></ng-icon>
  </button>
</div>
